export class AuthError extends Error {
  constructor(
    message: string,
    public readonly code?: string
  ) {
    super(message);
    this.name = "AuthError";
  }
}

/**
 * Attempt SSO token acquisition via Office.auth.getAccessToken().
 * While backend runs in DEV_MODE, SSO errors are non-fatal — we send a
 * dev token so the request goes through without authentication.
 * Once Entra SSO is enabled (WebApplicationInfo in manifest + DEV_MODE=false),
 * restore proper error handling here.
 */
export async function getAccessToken(): Promise<string> {
  // Browser testing fallback — no Outlook SSO available
  if (!(Office.context as any)?.auth) {
    return "dev-browser-token";
  }

  try {
    return await getSsoToken();
  } catch {
    // SSO not available (no WebApplicationInfo in manifest yet).
    // Backend is DEV_MODE=true so any token value is accepted.
    console.warn("[lio] SSO unavailable, using dev token");
    return "dev-outlook-token";
  }
}

async function getSsoToken(): Promise<string> {
  const result = await Office.auth.getAccessToken({
    allowSignInPrompt: true,
    allowConsentPrompt: true,
    forMSGraphAccess: false,
  });
  return result;
}